import React from "react";
import { Modal, Button } from "react-bootstrap";
import PaymentMethod from "../../home/components/payment-method";

function DeletePaymentMethodLayout(props) {
  return (
    <div>
      <Modal
        show={props.show}
        onHide={() => props.handleShow("DeletePaymentMethod", false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">
            Delete Payment Method
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You are about to delete a payment method. Please make sure you have
            at least one payment method on file so that you continue to make
            your payments on time!
          </p>

          <PaymentMethod
            paymentMethod={props.paymentMethod}
            handleShow={props.handleShow}
            viewState={{ showActions: false, showSelect: false, modal: true }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-danger"
            onClick={() =>
              props.deletePayment(props.paymentMethod.id, props.currentPlan)
            }
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DeletePaymentMethodLayout;



// WEBPACK FOOTER //
// ./src/home/components/delete-payment-method-layout.js